/**
 * @file PushAssetViewerPage.js
 * @description Loads the asset referenced by a push notification and displays it the same
 * way an asset link opens from a message in the inbox.
 */
import { useEffect, useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes';
import { fetchAssetByID } from '../../../services/clientService';
import AssetViewModal from '../../ui/modals/AssetViewModal';

function PushAssetViewerPage() {
    const { assetId } = useParams();
    const navigate = useNavigate();
    const [asset, setAsset] = useState(null);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        let isActive = true;

        async function loadAsset() {
            try {
                const fetchedAsset = await fetchAssetByID(assetId);
                if (isActive) {
                    setAsset(fetchedAsset);
                }
            } catch (error) {
                console.error('Unable to load the push notification asset', error);
                if (isActive) {
                    setHasError(true);
                }
            }
        }

        loadAsset();

        return () => {
            isActive = false;
        };
    }, [assetId]);

    function closeViewer() {
        navigate(ROUTES.ROOT, { replace: true });
    }

    if (hasError || (asset && !asset.url)) {
        return <Navigate to={ROUTES.ROOT} replace />;
    }

    if (!asset) {
        return null;
    }

    return (
        <AssetViewModal
            onHide={closeViewer}
            title={asset.name || 'Asset Preview'}
            text={asset.url}
        />
    );
}

export default PushAssetViewerPage;
